import React, { useEffect, useState } from "react";
// import Intercom from '@intercom/messenger-js-sdk';

import useMediaQuery from "@mui/material/useMediaQuery";

import Footer from "../../components/Footer";
import Hero from "../../components/Hero";
import Gameboard from "../../components/gameboard";
import LeaderBoard from "../../components/LeaderBoard";
import YetiKpiBox from "../../components/YetiKpiBox";
import AddKpiBox from "../../components/YetiKpiBox/AddKpiBox";
import SoftTypography from "../../components/SoftTypography";
import SoftBox from "../../components/SoftBox";
import SoftButton from "../../components/SoftButton";
import { useNavigate } from "react-router-dom";
import onBoardingImage from "../../img/onBoarding.jpg";
import CloseIcon from '@mui/icons-material/Close';
import { formatNumber } from "../../helpers/formatter";
import {UseSubscriptionLevel} from "../../hooks/company";
import { useOnlineStatus } from "../../hooks/useNetwork";
import { useSyncOfflineData } from "../../hooks/useSyncOfflineData";

import {
  UseUserDetails,
  UseIsDemo,
  UseLoading,
  UseIsAdmin,
  UseUpdateUserDetails,
} from "../../hooks/auth";
import { UseGroupKpis, UseMyKpis } from "../../hooks/kpi";
import LoadingScreen from "../../components/LoadingScreen";
import "./homepageStyles.css";
import { signOutUser } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { homePropmt, installApp } from "../../hooks/addToHome";
import { PUT_USER, GET_USER } from "../../api/user";
// import DemoOnboarding from "../../components/DemoOnboarding/DemoOnboarding";

// Icons
// import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
// import { borderRadius, fontSize, fontWeight, lineHeight, textAlign } from "@mui/system";
// import boxShadow from "../../assets/theme/functions/boxShadow";
import { styled } from '@mui/material/styles';
import { Tooltip, tooltipClasses, Modal, Box, Grid, Dialog, DialogContent, DialogActions, Divider } from '@mui/material';

// Add this custom tooltip component
const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 425,
    background: 'linear-gradient(180deg, #101828 0%, #39558E 100%)',
    boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.25)',
    color: '#101828',
  },
});

// Add this custom tooltip content component
const CustomTooltipContent = React.forwardRef(({ closeTooltip }, ref) => (
  <SoftBox ref={ref} sx={{ p: 2, textAlign: 'left !important' }}>
    <SoftTypography variant="h6" component="h3" sx={{ mb: 1, fontWeight: 'bold', color: "#FFFFFF" }}>
      King of the mountain
    </SoftTypography>
    <SoftTypography variant="body2" sx={{color: "#FFFFFF"}}>
      Navigate seamlessly with our Sidebar. Access key sections like Players, Bad guy, Hub, and more.
    </SoftTypography>
    <SoftBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: "2rem" }}>
      <SoftTypography variant="body2" sx={{color: "#FFFFFF"}}>
        3/3
      </SoftTypography>
      <SoftBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <SoftTypography variant="body2" sx={{color: "#FFFFFF", marginRight: "0.5rem", cursor: "pointer"}} onClick={closeTooltip}>
          Done
        </SoftTypography>
        <SoftButton
          variant="outlined"
          onClick={closeTooltip}
          sx={{
            background: "#FFFFFF",
            borderRadius: "4px",
            border: "1px solid #EAECF0",
            color: "#2152FF !important",
            textTransform: "capitalize !important",
            paddingTop: "4px",
            paddingBottom: "4px",
          }}
        >
          End Tutorial
        </SoftButton>
      </SoftBox>
    </SoftBox>
  </SoftBox>
));

// Add this new custom tooltip content component
const CustomTooltipContent2 = React.forwardRef(({ closeTooltip, onNext }, ref) => (
  <SoftBox ref={ref} sx={{ p: 2, textAlign: 'left !important' }}>
    <SoftTypography variant="h6" component="h3" sx={{ mb: 1, fontWeight: 'bold', color: "#FFFFFF" }}>
      Team Performance VS. The Yeti
    </SoftTypography>
    <SoftTypography variant="body2" sx={{color: "#FFFFFF"}}>
      Widgets provide at-a-glance insights! Customize your dashboard with Widgets to monitor essential metrics and achievements
    </SoftTypography>
    <SoftBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: "2rem" }}>
      <SoftTypography variant="body2" sx={{color: "#FFFFFF"}}>
        2/3
      </SoftTypography>
      <SoftBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <SoftTypography variant="body2" sx={{color: "#FFFFFF", marginRight: "0.5rem", cursor: "pointer"}} onClick={closeTooltip}>
          Skip Tutorial
        </SoftTypography>
        <SoftButton
          variant="outlined"
          sx={{
            background: "#FFFFFF",
            borderRadius: "4px",
            border: "1px solid #EAECF0",
            color: "#2152FF !important",
            textTransform: "capitalize !important",
            paddingTop: "4px",
            paddingBottom: "4px",
          }}
          onClick={onNext}
        >
          Next
        </SoftButton>
      </SoftBox>
    </SoftBox>
  </SoftBox>
));

function Homepage() {

  const [openDailyTargetDialog, setOpenDailyTargetDialog] = useState(false);
  const isLoading = UseLoading();
  const isAdmin = UseIsAdmin();
  const { _id: userId, onboardingStatus, onboardingBannerDismissed, isAdmin: isRealAdmin, email: userEmail, firstName: userfirstName, lastName: userlastName, logins } = UseUserDetails();
  const isDemo = UseIsDemo();
  const groupKpis = UseGroupKpis();
  const [kpis, setKpis] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSubscribed = UseSubscriptionLevel();
  const [showDemo, setShowDemo] = useState(
    isDemo && onboardingStatus !== "completed",
  );
  const [bannerDismissed, setBannerDismissed] = useState(onboardingBannerDismissed);
  const userKpis = UseMyKpis();
  const isOnline = useOnlineStatus();
  const { syncOfflineData } = useSyncOfflineData();

  console.log("Group KPI data:", kpis);

  useEffect(() => {
    const handlePageFullyLoaded = () => {
      if (isOnline) {
        syncOfflineData(isOnline);
      }
    };
    if (document.readyState === 'complete') {
      handlePageFullyLoaded();
    } else {
      window.addEventListener('load', handlePageFullyLoaded);
      return () => window.removeEventListener('load', handlePageFullyLoaded);
    }
  }, [isOnline, syncOfflineData]);

  // Intercom({
  //   app_id: 'xpad1tsg',
  //   name: `${userfirstName} ${userlastName}`,
  //   email: userEmail
  // })

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const screenWidth = window.innerWidth;
  console.log("screenWidth", screenWidth);

  const [isVisible, setIsVisible] = useState(() => {
    console.log("onboardingBannerDismissed for this user?:", onboardingBannerDismissed);
    console.log("undefined?", onboardingBannerDismissed === undefined);
    console.log("isVisible initial state:", !onboardingBannerDismissed || true);
    if (onboardingBannerDismissed === undefined) {
      return true; // Default to visible if the value is undefined
    } else if (onboardingBannerDismissed === false) {
      return true; // Show the banner if it has not been dismissed
    } else if (onboardingBannerDismissed === true) {
      return false; // Hide the banner if it has been dismissed
    }
  });

  const handleHide = async () => {
    setIsVisible(false);
    try {
      const response = await PUT_USER(userId, { onboardingBannerDismissed: true }, true);
      if (response.status === 200) {
        console.log("User onboarding status updated successfully");
      }
    } catch (error) {
      console.error("Error updating user onboarding status:", error);
    }
    dispatch({
      type: "UPDATE_USER_DETAILS",
      payload: {
      onboardingBannerDismissed: true
      }
    });
  };


  useEffect(() => {
    if (!isLoading) {
      if (!userId) {
        dispatch(signOutUser());
        window.sessionStorage.removeItem("hasRunBlackout");
        document.location.href = "/";
      }
    }
  }, [isLoading, userKpis, userId]);

  useEffect(() => {
    if (groupKpis) {
      const kpiSummary = groupKpis?.filter(kpi => !kpi.isDraft).map((kpiItem) => ({
        ...kpiItem,
        amount: userKpis?.month[kpiItem._id]?.amt ?? 0,
        points: userKpis?.month[kpiItem._id]?.pts ?? 0,
        target: kpiItem.target,
      }));
      setKpis(kpiSummary);
    }
  }, [groupKpis, userKpis]);

  useEffect(() => {
    const targetNode = document.getElementById("root");
    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver(() => {
      if (document.getElementById("ConfirmationModelSuccessBtn")) {
        installApp();
        observer.disconnect();
      } else if (document.getElementById("addToHomeClick")) {
        homePropmt();
      }
    });
    observer.observe(targetNode, config);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [openModal, setOpenModal] = useState(false);
  const [triggerTooltip, setTriggerTooltip] = useState(false);

  useEffect(() => {
    if (logins === 0 && isSubscribed > 0) {
      setOpenModal(true);
    }
  }, [logins, isSubscribed]);

  const handleCloseModal = () => {
    setOpenModal(false);
    setTriggerTooltip(true);
  };

  const handleCloseModal2 = () => {
    setOpenModal(false);
    handleHide();
  };
  
  const style = {
    position: 'absolute',
    top: '35%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '8px',
    boxShadow: 24,
    padding: '1.75rem',
    maxWidth: { mini: "90%", xs: "90%", sm: "600px" },
    width: "100%",
    overflow: "visible",
    background: "#FFF !important"
  };

  const [openGameboardTooltip, setOpenGameboardTooltip] = useState(false);
  const [openYetiTooltip, setOpenYetiTooltip] = useState(false);

  const handleNextTooltip2 = () => {
    setOpenYetiTooltip(false);
    setOpenGameboardTooltip(true);
  };

  const handleNextTooltip = () => {
    setOpenYetiTooltip(true);
  };

  const handleCloseTooltip = () => {
    handleHide();
  };


  const closeGameboardTooltip = () => {
    setOpenGameboardTooltip(false);
    handleHide();
  };

  const closeYetiTooltip = () => {
    setOpenYetiTooltip(false);
    handleHide();
  };

  return (
    <SoftBox sx={{ positon: "relative", marginTop: "2rem" }}>
      {/* eslint-disable-next-line no-nested-ternary */}
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <SoftBox>
          <Box>
          {isVisible && <SoftBox className={alert} sx={{padding: { mini: "0.5rem", xxs: "1.5rem 1.5rem 0rem 1.5rem" }}}>
              <Grid container sx={{padding: "20px", backgroundColor: "#ffffff", alignItems: "center", display: isSmallScreen ? "none" : "flex", borderRadius: "8px" }}>
                <Grid item mini={2}>
                    <SoftTypography sx={{ color: "#000000", fontSize: { mini: "18px", md: "16px" }, lineHeight: "24px", fontWeight: "500" }} variant="h3">
                      Get started with Game My Biz
                    </SoftTypography>
                </Grid>
                <Grid item mini={8}>
                  <div style={{ display: 'flex', }}>
                    <SoftButton color="primary" sx={{ borderRadius: "4px", fontSize: { mini: "14px", md: "13.5px" }, marginRight: ".5rem", textTransform: "capitalize" }} onClick={() => navigate("/settings/players")}>
                      <svg style={{marginRight: ".5rem"}} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="8" cy="8" r="7.66667" fill="#FCFCFD" stroke="#98A2B3" /> <path d="M7.33467 11V5.58667L6.28 5.82933V5.10133L7.72667 4.46667H8.36133V11H7.33467Z" fill="#667085"/> </svg>
                      Invite Players
                    </SoftButton>
                    <SoftButton color="primary" sx={{ borderRadius: "4px", fontSize: { mini: "14px", md: "13.5px" }, marginRight: ".5rem", textTransform: "capitalize" }} onClick={() => navigate("/gameboard-library")}>
                      <svg style={{marginRight: ".5rem"}} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="7.66667" fill="#FCFCFD" stroke="#98A2B3" />
                        <path d="M5.532 11V10.2907C5.95511 9.95467 6.35956 9.61556 6.74533 9.27333C7.13111 8.93111 7.47333 8.59511 7.772 8.26533C8.07689 7.92933 8.31644 7.60267 8.49067 7.28533C8.66489 6.96178 8.752 6.65067 8.752 6.352C8.752 6.15289 8.71778 5.96622 8.64933 5.792C8.58089 5.61156 8.46889 5.46844 8.31333 5.36267C8.15778 5.25067 7.94933 5.19467 7.688 5.19467C7.296 5.19467 7.00044 5.31911 6.80133 5.568C6.60844 5.81689 6.51511 6.11555 6.52133 6.464H5.56C5.56622 6.00356 5.66267 5.61778 5.84933 5.30667C6.04222 4.99555 6.29733 4.75911 6.61467 4.59733C6.93822 4.43555 7.30222 4.35467 7.70667 4.35467C8.32267 4.35467 8.81422 4.52889 9.18133 4.87733C9.55467 5.21956 9.74133 5.69867 9.74133 6.31467C9.74133 6.68178 9.65111 7.04578 9.47067 7.40667C9.29645 7.76756 9.06622 8.116 8.78 8.452C8.5 8.78178 8.19822 9.09289 7.87467 9.38533C7.55111 9.67778 7.24311 9.94222 6.95067 10.1787H9.93733V11H5.532Z" fill="#667085"/>
                      </svg>
                      Customize Gameboard
                    </SoftButton>
                    <SoftButton color="primary" sx={{ borderRadius: "4px", fontSize: { mini: "14px", md: "13.5px" }, textTransform: "capitalize" }} onClick={() => navigate("/workspace-kpi")}>
                      <svg style={{marginRight: ".5rem"}} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="7.66667" fill="#FCFCFD" stroke="#98A2B3" />
                        <path d="M7.75333 11.112C7.33022 11.112 6.94444 11.0373 6.596 10.888C6.25378 10.7324 5.98 10.4991 5.77467 10.188C5.56933 9.87689 5.46044 9.488 5.448 9.02133H6.428C6.44044 9.36978 6.55867 9.66533 6.78267 9.908C7.01289 10.1444 7.33644 10.2627 7.75333 10.2627C8.15156 10.2627 8.45644 10.1538 8.668 9.936C8.87956 9.712 8.98533 9.43511 8.98533 9.10533C8.98533 8.70711 8.84222 8.41156 8.556 8.21867C8.276 8.02578 7.93067 7.92933 7.52 7.92933H7.03467V7.108H7.52933C7.89644 7.108 8.192 7.02089 8.416 6.84667C8.64622 6.67244 8.76133 6.42667 8.76133 6.10933C8.76133 5.84178 8.67111 5.624 8.49067 5.456C8.31644 5.288 8.06756 5.204 7.744 5.204C7.408 5.204 7.14356 5.30355 6.95067 5.50267C6.75778 5.69555 6.652 5.93822 6.63333 6.23067H5.65333C5.66578 5.85111 5.75911 5.52133 5.93333 5.24133C6.11378 4.96133 6.35956 4.74355 6.67067 4.588C6.98178 4.43244 7.33956 4.35467 7.744 4.35467C8.17956 4.35467 8.54356 4.43244 8.836 4.588C9.13467 4.73733 9.35867 4.94267 9.508 5.204C9.66356 5.45911 9.74133 5.73911 9.74133 6.044C9.74133 6.39244 9.64489 6.69733 9.452 6.95867C9.25911 7.22 9.00089 7.39422 8.67733 7.48133C9.05067 7.56222 9.35867 7.74578 9.60133 8.032C9.844 8.312 9.96533 8.676 9.96533 9.124C9.96533 9.48489 9.88133 9.81778 9.71333 10.1227C9.54533 10.4213 9.29644 10.6609 8.96667 10.8413C8.63689 11.0218 8.23244 11.112 7.75333 11.112Z" fill="#667085"/>
                      </svg>
                      Add metrics
                    </SoftButton>
                    </div>
                </Grid>
                <Grid item sx={{ display: 'flex', justifyContent: 'flex-end' }} mini={2}>
                  <SoftButton onClick={() => setOpenModal(true)} sx={{ borderRadius: "4px", fontSize: { mini: "14px", md: "13.5px" }, textTransform: "capitalize", marginRight: "24px" }}>
                    Interactive Tour
                  </SoftButton>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" style={{cursor: "pointer"}} onClick={handleHide}>
                    <path d="M1.26668 9.66683L0.333344 8.7335L4.06668 5.00016L0.333344 1.26683L1.26668 0.333496L5.00001 4.06683L8.73334 0.333496L9.66668 1.26683L5.93334 5.00016L9.66668 8.7335L8.73334 9.66683L5.00001 5.9335L1.26668 9.66683Z" fill="#000"/>
                  </svg>
                </Grid>
              </Grid>
            </SoftBox>}
            <Hero triggerTooltip={triggerTooltip} onNextTooltip={handleNextTooltip} closeTooltip={handleCloseTooltip}/>
            <Grid
              container
              spacing={4}
              sx={{ padding: { xxs: "1.5rem" },paddingTop: { md: "10px" } }}
            >
              {kpis.length ? (
                <>
                  <Grid item mini={12} md={12} lg={6}>
                    <CustomWidthTooltip 
                      title={<CustomTooltipContent closeTooltip={closeGameboardTooltip} />}
                      placement="right"
                      arrow
                      open={openGameboardTooltip}
                    >
                      <div>
                        <Gameboard kpis={kpis} />
                      </div>
                    </CustomWidthTooltip>
                  </Grid>
                  <Grid item mini={12} md={12} lg={6}>
                    <CustomWidthTooltip 
                      title={<CustomTooltipContent2 closeTooltip={closeYetiTooltip} onNext={handleNextTooltip2} />}
                      placement="left"
                      arrow
                      open={openYetiTooltip}
                    >
                      <SoftBox
                        sx={{
                          height: { mini: "835px", xxs: "875px", md: "100%" },
                          padding: { mini: "0px 24px 0px 24px", xxs: "unset" },
                          ...(isSmallScreen && ({ height: "unset", minHeight: "100px !important" }))
                        }}
                      >
                        <SoftBox
                          sx={{
                            background: "#fff",
                            paddingTop: { mini: "16px", sm: "1rem" },
                            paddingBottom: "2rem",
                            overflowX: "hidden",
                            borderRadius: "12px",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: { mini: "960px", xxs: "1000px", md: "850px" },
                            ...(isSmallScreen && ({ maxHeight: "unset", minHeight: "100px" }))
                          }}
                        >
                          <SoftBox
                            sx={{
                              paddingLeft: { mini: "16px", sm: "2rem" },
                              paddingRight: { mini: "16px", sm: "2rem" },
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center"
                            }}
                          >
                            <SoftTypography
                              sx={{
                                textFillColor: "primary.main", 
                                color: "#000000",
                                fontSize: { mini: "14px", md: '24px', sm: "24px", },
                                lineHeight: { mini: "18px", md: '24px', sm: "24px" },
                                fontWeight: { mini: 500, sm: 600 },
                                ...(screenWidth <= 1280 && ({ fontSize: "18px", lineHeight: "18px" }))
                              }}
                            > 
                              Team Performance VS. The Yeti
                            </SoftTypography>
                            <SoftTypography
                              onClick={() => isAdmin ? navigate('/workspace-kpi') : setOpenDailyTargetDialog(true)}
                              sx={{
                                color: "primary.main",
                                fontSize: '12px',
                                fontWeight: '600',
                                cursor: 'pointer'
                              }}>
                                {isAdmin ?
                                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.5 13.125C8.775 13.125 7.375 11.725 7.375 10C7.375 8.275 8.775 6.875 10.5 6.875C12.225 6.875 13.625 8.275 13.625 10C13.625 11.725 12.225 13.125 10.5 13.125ZM10.5 8.125C9.46667 8.125 8.625 8.96667 8.625 10C8.625 11.0333 9.46667 11.875 10.5 11.875C11.5333 11.875 12.375 11.0333 12.375 10C12.375 8.96667 11.5333 8.125 10.5 8.125Z" fill="#292D32"/>
                                    <path d="M13.1748 18.4932C12.9998 18.4932 12.8248 18.4682 12.6498 18.4265C12.1332 18.2849 11.6998 17.9599 11.4248 17.5015L11.3248 17.3349C10.8332 16.4849 10.1582 16.4849 9.6665 17.3349L9.57484 17.4932C9.29984 17.9599 8.8665 18.2932 8.34984 18.4265C7.82484 18.5682 7.28317 18.4932 6.82484 18.2182L5.3915 17.3932C4.88317 17.1015 4.5165 16.6265 4.35817 16.0515C4.20817 15.4765 4.28317 14.8849 4.57484 14.3765C4.8165 13.9515 4.88317 13.5682 4.7415 13.3265C4.59984 13.0849 4.2415 12.9432 3.74984 12.9432C2.53317 12.9432 1.5415 11.9515 1.5415 10.7349V9.26821C1.5415 8.05154 2.53317 7.05987 3.74984 7.05987C4.2415 7.05987 4.59984 6.91821 4.7415 6.67654C4.88317 6.43487 4.82484 6.05154 4.57484 5.62654C4.28317 5.11821 4.20817 4.51821 4.35817 3.95154C4.50817 3.37654 4.87484 2.90154 5.3915 2.60987L6.83317 1.78487C7.77484 1.22654 9.0165 1.55154 9.58317 2.50987L9.68317 2.67654C10.1748 3.52654 10.8498 3.52654 11.3415 2.67654L11.4332 2.51821C11.9998 1.55154 13.2415 1.22654 14.1915 1.79321L15.6248 2.61821C16.1332 2.90987 16.4998 3.38487 16.6582 3.95987C16.8082 4.53487 16.7332 5.12654 16.4415 5.63487C16.1998 6.05987 16.1332 6.44321 16.2748 6.68488C16.4165 6.92654 16.7748 7.06821 17.2665 7.06821C18.4832 7.06821 19.4748 8.05987 19.4748 9.27654V10.7432C19.4748 11.9599 18.4832 12.9515 17.2665 12.9515C16.7748 12.9515 16.4165 13.0932 16.2748 13.3349C16.1332 13.5765 16.1915 13.9599 16.4415 14.3849C16.7332 14.8932 16.8165 15.4932 16.6582 16.0599C16.5082 16.6349 16.1415 17.1099 15.6248 17.4015L14.1832 18.2265C13.8665 18.4015 13.5248 18.4932 13.1748 18.4932ZM10.4998 15.4099C11.2415 15.4099 11.9332 15.8765 12.4082 16.7015L12.4998 16.8599C12.5998 17.0349 12.7665 17.1599 12.9665 17.2099C13.1665 17.2599 13.3665 17.2349 13.5332 17.1349L14.9748 16.3015C15.1915 16.1765 15.3582 15.9682 15.4248 15.7182C15.4915 15.4682 15.4582 15.2099 15.3332 14.9932C14.8582 14.1765 14.7998 13.3349 15.1665 12.6932C15.5332 12.0515 16.2915 11.6849 17.2415 11.6849C17.7748 11.6849 18.1998 11.2599 18.1998 10.7265V9.25987C18.1998 8.73487 17.7748 8.30154 17.2415 8.30154C16.2915 8.30154 15.5332 7.93487 15.1665 7.29321C14.7998 6.65154 14.8582 5.80987 15.3332 4.99321C15.4582 4.77654 15.4915 4.51821 15.4248 4.26821C15.3582 4.01821 15.1998 3.81821 14.9832 3.68487L13.5415 2.85987C13.1832 2.64321 12.7082 2.76821 12.4915 3.13487L12.3998 3.29321C11.9248 4.11821 11.2332 4.58487 10.4915 4.58487C9.74984 4.58487 9.05817 4.11821 8.58317 3.29321L8.4915 3.12654C8.28317 2.77654 7.8165 2.65154 7.45817 2.85987L6.0165 3.69321C5.79984 3.81821 5.63317 4.02654 5.5665 4.27654C5.49984 4.52654 5.53317 4.78487 5.65817 5.00154C6.13317 5.81821 6.1915 6.65987 5.82484 7.30154C5.45817 7.94321 4.69984 8.30987 3.74984 8.30987C3.2165 8.30987 2.7915 8.73487 2.7915 9.26821V10.7349C2.7915 11.2599 3.2165 11.6932 3.74984 11.6932C4.69984 11.6932 5.45817 12.0599 5.82484 12.7015C6.1915 13.3432 6.13317 14.1849 5.65817 15.0015C5.53317 15.2182 5.49984 15.4765 5.5665 15.7265C5.63317 15.9765 5.7915 16.1765 6.00817 16.3099L7.44984 17.1349C7.62484 17.2432 7.83317 17.2682 8.02484 17.2182C8.22484 17.1682 8.3915 17.0349 8.49984 16.8599L8.5915 16.7015C9.0665 15.8849 9.75817 15.4099 10.4998 15.4099Z" fill="#292D32"/>
                                  </svg>
                                 : 
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_12719_54496)">
                                    <path d="M19.257 10.7383C19.116 12.5104 18.4692 14.2049 17.3935 15.6202C16.3179 17.0356 14.8585 18.1125 13.1888 18.7229C11.5191 19.3333 9.70932 19.4515 7.9744 19.0636C6.23949 18.6757 4.65239 17.7979 3.40166 16.5346C2.15093 15.2712 1.28914 13.6754 0.918692 11.9366C0.548239 10.1979 0.684688 8.3894 1.31183 6.72593C1.93897 5.06247 3.03044 3.614 4.45657 2.5526C5.88269 1.4912 7.58353 0.861489 9.35701 0.738281" stroke="#475467" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M13.9856 11.5577C13.7276 12.2217 13.3082 12.8109 12.7653 13.2721C12.2223 13.7332 11.573 14.0518 10.876 14.1989C10.1791 14.3461 9.45639 14.3172 8.77339 14.1148C8.09038 13.9125 7.46859 13.543 6.96424 13.04C6.45988 12.5369 6.08888 11.9161 5.88477 11.2336C5.68066 10.5511 5.64989 9.82854 5.79524 9.13118C5.94059 8.43382 6.25747 7.78369 6.71723 7.23957C7.17699 6.69546 7.76512 6.27453 8.42845 6.01484M9.99988 10.0006L13.5713 6.42913M13.5713 6.42913L16.4285 7.14341L19.2856 4.28627L16.4285 3.57199L15.7142 0.714844L12.857 3.57199L13.5713 6.42913Z" stroke="#475467" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_12719_54496">
                                    <rect width="24" height="24" fill="white"/>
                                    </clipPath>
                                    </defs>
                                  </svg>
                                }
                            </SoftTypography>
                          <Dialog
                            open={openDailyTargetDialog}
                            onClose={() => setOpenDailyTargetDialog(false)}
                            sx={{
                              ".MuiPaper-root": {
                                borderRadius: "8px",
                                background: 'linear-gradient(156.05deg, rgba(12, 12, 13, 0.5) 3.85%, rgba(12, 12, 13, 0.65) 50.21%, rgba(12, 12, 13, 0.51) 98.53%)',
                                boxShadow: 24,
                                padding: '1.75rem',
                                maxWidth: { mini: "90%", xs: "90%", sm: "600px" },
                                width: "100%",
                                overflow: "visible",
                                backdropFilter: 'blur(14px)'
                              },
                            }}
                          >
                            <SoftBox display="flex" alignItems="center" sx={{ padding: "0 !important" }}>
                              <SoftBox display="flex" alignItems="center">
                                <SoftBox display="flex" flexDirection="column">
                                  <SoftTypography
                                    component="h3"
                                    sx={{
                                      fontSize: "18px",
                                      color: "#FFF",
                                      margin: 0,
                                      padding: 0,
                                      fontWeight: "500",
                                    }}
                                  >
                                    My Metrics Targets
                                  </SoftTypography>
                                </SoftBox>
                              </SoftBox>
                              <div className="ml-auto">
                                <SoftButton
                                  variant="outlined"
                                  color="white"
                                  sx={{
                                    "& svg": { fontSize: "1rem !important" },
                                    borderRadius: "50%",
                                    minWidth: "max-content",
                                    minHeight: "max-content",
                                    padding: "0.25rem",
                                  }}
                                  onClick={() => setOpenDailyTargetDialog(false)}
                                >
                                  <CloseIcon />
                                </SoftButton>
                              </div>
                            </SoftBox>
                            <Divider
                                sx={{
                                  backgroundColor: "#D5EBFF",
                                }}
                              />
                            <DialogContent sx={{ padding: "0 !important", maxHeight: "400px", overflow: "auto" }}>
                              {kpis?.map((kpi) => (
                                <SoftBox key={kpi._id} sx={{
                                  background: '#2A292A',
                                  padding: '16px',
                                  marginBottom: '12px',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: '12px',
                                  borderRadius: '6px'
                                }}>
                                  <SoftBox sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start!important',
                                  }}>
                                    <SoftTypography sx={{
                                      color: '#D0D5DD',
                                      fontSize: '24px',
                                      fontWeight: 500,
                                      lineHeight: '30px',
                                      textDecoration: 'underline'
                                    }}>
                                      {kpi?.title || 'Unknown'}
                                    </SoftTypography>
                                    {kpi.metricType && !kpi.integrationId && (
                                      <SoftTypography sx={{
                                        color: '#F9FAFB',
                                        fontSize: '20px', 
                                        fontWeight: 500,
                                        lineHeight: '24px'
                                      }}>
                                        {formatNumber(kpi.target, kpi.kind)}
                                      </SoftTypography>
                                    )}
                                  </SoftBox>
                                  {kpi.integrationId || !kpi.metricType && (
                                    <>
                                      <SoftBox>
                                        <SoftTypography sx={{
                                          color: '#F2F4F7',
                                          fontSize: '14px',
                                          fontWeight: 500,
                                          lineHeight: '30px'
                                        }}>Daily Target: No Target, No Points</SoftTypography>
                                      </SoftBox>
                                      <SoftBox sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        border: '1px dashed #667085',
                                        borderRadius: '8px',
                                        padding: '12px'
                                      }}>
                                        <SoftBox sx={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                        }}>
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.25813 1.50391L3.37813 2.38266L4.6875 3.69141L5.56625 2.81266L4.25813 1.50391ZM15.7425 1.50391L14.4331 2.81266L15.3125 3.69141L16.6213 2.38328L15.7425 1.50391ZM10 1.89391C9.79375 1.89557 9.58542 1.90891 9.375 1.93391H9.35625C6.82125 2.22453 4.80375 4.27266 4.45312 6.79641C4.17313 8.82766 5.01062 10.6695 6.40625 11.8558C6.97705 12.3431 7.36317 13.0116 7.5 13.7495V17.4995H8.925C9.1425 17.8727 9.53938 18.1245 10 18.1245C10.4606 18.1245 10.8575 17.8727 11.075 17.4995H12.5V14.9995H12.5588V14.257C12.5588 13.3408 13.035 12.417 13.8088 11.6989C14.8438 10.6627 15.625 9.19078 15.625 7.50016C15.625 4.41266 13.0837 1.86516 10 1.89391ZM10 3.14391C12.4156 3.11016 14.375 5.08766 14.375 7.50016C14.375 8.80891 13.7688 9.96141 12.9294 10.8002L12.9494 10.8202C12.1156 11.5896 11.5763 12.6258 11.4244 13.7502H8.69062C8.55312 12.6789 8.09375 11.642 7.22563 10.8983C6.12125 9.96078 5.46313 8.54828 5.68313 6.95328C5.95625 4.98453 7.55375 3.40141 9.51125 3.18453C9.67288 3.16212 9.83563 3.14876 9.99875 3.14453L10 3.14391ZM1.25 7.50016V8.75016H3.125V7.50016H1.25ZM16.875 7.50016V8.75016H18.75V7.50016H16.875ZM4.6875 12.5589L3.37875 13.867L4.25813 14.7464L5.56562 13.4377L4.6875 12.5589ZM15.3125 12.5589L14.4338 13.4377L15.7419 14.7464L16.6213 13.867L15.3125 12.5589ZM8.75 15.0002H11.25V16.2502H8.75V15.0002Z" fill="#AFA3A3"/>
                                          </svg>
                                          <SoftTypography sx={{
                                            color: '#F2F4F7',
                                            marginLeft: '0.25rem',
                                            fontSize: '14px',
                                            fontWeight: 500,
                                            lineHeight: '30px'
                                          }}>Current Value: {kpi.amount}</SoftTypography>
                                        </SoftBox>
                                      </SoftBox>
                                    </>
                                  )}
                                  {kpi.metricType === "progressive" && (
                                    <>
                                      <SoftBox>
                                        <SoftTypography sx={{
                                          color: '#F2F4F7',
                                          fontSize: '14px',
                                          fontWeight: 500,
                                          lineHeight: '30px'
                                        }}>Daily Target: {formatNumber(kpi.target, kpi.kind)}</SoftTypography>
                                      </SoftBox>
                                      <SoftBox sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        border: '1px dashed #667085',
                                        borderRadius: '8px',
                                        padding: '12px'
                                      }}>
                                        <SoftBox sx={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                        }}>
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.25813 1.50391L3.37813 2.38266L4.6875 3.69141L5.56625 2.81266L4.25813 1.50391ZM15.7425 1.50391L14.4331 2.81266L15.3125 3.69141L16.6213 2.38328L15.7425 1.50391ZM10 1.89391C9.79375 1.89557 9.58542 1.90891 9.375 1.93391H9.35625C6.82125 2.22453 4.80375 4.27266 4.45312 6.79641C4.17313 8.82766 5.01062 10.6695 6.40625 11.8558C6.97705 12.3431 7.36317 13.0116 7.5 13.7495V17.4995H8.925C9.1425 17.8727 9.53938 18.1245 10 18.1245C10.4606 18.1245 10.8575 17.8727 11.075 17.4995H12.5V14.9995H12.5588V14.257C12.5588 13.3408 13.035 12.417 13.8088 11.6989C14.8438 10.6627 15.625 9.19078 15.625 7.50016C15.625 4.41266 13.0837 1.86516 10 1.89391ZM10 3.14391C12.4156 3.11016 14.375 5.08766 14.375 7.50016C14.375 8.80891 13.7688 9.96141 12.9294 10.8002L12.9494 10.8202C12.1156 11.5896 11.5763 12.6258 11.4244 13.7502H8.69062C8.55312 12.6789 8.09375 11.642 7.22563 10.8983C6.12125 9.96078 5.46313 8.54828 5.68313 6.95328C5.95625 4.98453 7.55375 3.40141 9.51125 3.18453C9.67288 3.16212 9.83563 3.14876 9.99875 3.14453L10 3.14391ZM1.25 7.50016V8.75016H3.125V7.50016H1.25ZM16.875 7.50016V8.75016H18.75V7.50016H16.875ZM4.6875 12.5589L3.37875 13.867L4.25813 14.7464L5.56562 13.4377L4.6875 12.5589ZM15.3125 12.5589L14.4338 13.4377L15.7419 14.7464L16.6213 13.867L15.3125 12.5589ZM8.75 15.0002H11.25V16.2502H8.75V15.0002Z" fill="#AFA3A3"/>
                                          </svg>
                                          <SoftTypography sx={{
                                            color: '#F2F4F7',
                                            marginLeft: '0.25rem',
                                            fontSize: '14px',
                                            fontWeight: 500,
                                            lineHeight: '30px'
                                          }}>Point Rule: For every {formatNumber(kpi.target, kpi.kind)} you earn, you get {kpi.pointScale * kpi.target} points</SoftTypography>
                                        </SoftBox>
                                      </SoftBox>
                                    </>
                                  )}
                                  {kpi.metricType === "anchor" && (
                                    <>
                                      <SoftBox>
                                        <SoftTypography sx={{
                                          color: '#F2F4F7',
                                          fontSize: '14px',
                                          fontWeight: 500,
                                          lineHeight: '30px'
                                        }}>Benchmark Target: {formatNumber(kpi.target, kpi.kind)} = {kpi.optional.benchmarkPoint} points</SoftTypography>
                                      </SoftBox>
                                      <SoftBox sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start!important',
                                        border: '1px dashed #667085',
                                        borderRadius: '8px',
                                        padding: '12px'
                                      }}>
                                        <SoftBox sx={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'flex-start!important',
                                        }}>
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.25813 1.50391L3.37813 2.38266L4.6875 3.69141L5.56625 2.81266L4.25813 1.50391ZM15.7425 1.50391L14.4331 2.81266L15.3125 3.69141L16.6213 2.38328L15.7425 1.50391ZM10 1.89391C9.79375 1.89557 9.58542 1.90891 9.375 1.93391H9.35625C6.82125 2.22453 4.80375 4.27266 4.45312 6.79641C4.17313 8.82766 5.01062 10.6695 6.40625 11.8558C6.97705 12.3431 7.36317 13.0116 7.5 13.7495V17.4995H8.925C9.1425 17.8727 9.53938 18.1245 10 18.1245C10.4606 18.1245 10.8575 17.8727 11.075 17.4995H12.5V14.9995H12.5588V14.257C12.5588 13.3408 13.035 12.417 13.8088 11.6989C14.8438 10.6627 15.625 9.19078 15.625 7.50016C15.625 4.41266 13.0837 1.86516 10 1.89391ZM10 3.14391C12.4156 3.11016 14.375 5.08766 14.375 7.50016C14.375 8.80891 13.7688 9.96141 12.9294 10.8002L12.9494 10.8202C12.1156 11.5896 11.5763 12.6258 11.4244 13.7502H8.69062C8.55312 12.6789 8.09375 11.642 7.22563 10.8983C6.12125 9.96078 5.46313 8.54828 5.68313 6.95328C5.95625 4.98453 7.55375 3.40141 9.51125 3.18453C9.67288 3.16212 9.83563 3.14876 9.99875 3.14453L10 3.14391ZM1.25 7.50016V8.75016H3.125V7.50016H1.25ZM16.875 7.50016V8.75016H18.75V7.50016H16.875ZM4.6875 12.5589L3.37875 13.867L4.25813 14.7464L5.56562 13.4377L4.6875 12.5589ZM15.3125 12.5589L14.4338 13.4377L15.7419 14.7464L16.6213 13.867L15.3125 12.5589ZM8.75 15.0002H11.25V16.2502H8.75V15.0002Z" fill="#AFA3A3"/>
                                          </svg>
                                          <SoftTypography sx={{
                                            color: '#F2F4F7',
                                            marginLeft: '0.25rem',
                                            fontSize: '14px',
                                            fontWeight: 500,
                                            lineHeight: '30px',
                                            marginTop: "-0.25rem"
                                          }}>Point Rule: </SoftTypography>
                                        </SoftBox>
                                        <SoftBox>
                                          <SoftBox sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-start!important',
                                          }}>
                                            <SoftBox sx={{alignItems: "start!important"}}>
                                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.8337 16.6668H9.16706V6.6668L4.58372 11.2501L3.40039 10.0668L10.0004 3.4668L16.6004 10.0668L15.4171 11.2501L10.8337 6.6668V16.6668Z" fill="#299E47"/>
                                              </svg>
                                            </SoftBox>
                                            <SoftBox sx={{alignItems: "start!important"}}>
                                              <SoftTypography sx={{
                                                color: '#F2F4F7',
                                                marginLeft: '0.25rem',
                                                fontSize: '14px',
                                                fontWeight: 500,
                                                lineHeight: '30px',
                                                marginTop: "-0.25rem"
                                              }}>{formatNumber(kpi.optional.point, kpi.kind)} above the target, you Earn {kpi.optional.aboveBenchmark} points more</SoftTypography>
                                            </SoftBox>
                                          </SoftBox>
                                          <SoftBox sx={{
                                            display: "flex", 
                                            justifyContent: "start!important",
                                            alignItems: "start!important"
                                          }}>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M9.16628 3.46602L10.8329 3.46602L10.8329 13.466L15.4163 8.88268L16.5996 10.066L9.99961 16.666L3.39961 10.066L4.58294 8.88268L9.16628 13.466L9.16628 3.46602Z" fill="#E5484D"/>
                                            </svg>
                                            <SoftTypography sx={{
                                              color: '#F2F4F7',
                                              fontSize: '14px',
                                              fontWeight: 500,
                                              lineHeight: '30px',
                                              left: "0!important",
                                              textAlign: 'left!important',
                                              marginLeft: '0.25rem',
                                            }}>
                                              {formatNumber(kpi.optional.point, kpi.kind)} below the target, you Loose {kpi.optional.belowBenchmark} points
                                            </SoftTypography>
                                          </SoftBox>
                                        </SoftBox>
                                      </SoftBox>
                                    </>
                                  )}
                                </SoftBox>
                              ))}
                            </DialogContent>
                            <DialogActions sx={{ padding: "0 !important", mt: 2 }}>
                              <SoftButton
                                onClick={() => setOpenDailyTargetDialog(false)}
                                sx={{
                                  background: '#FFFFFF',
                                  border: '1px solid #D0D5DD',
                                  borderRadius: '3px',
                                  color: '#344054',
                                  fontSize: '14px',
                                  fontWeight: 600,
                                  padding: '5px 40px!important',
                                  '&:hover': {
                                    background: '#F9FAFB'
                                  }
                                }}
                              >
                                Close
                              </SoftButton>
                            </DialogActions>
                          </Dialog>
                          </SoftBox>
                          <hr className="my-3 divide-slate-300"/>
                          <Box
                            sx={{
                              marginX: "auto",
                              width: "100%",
                              paddingX: { mini: "0.5rem", md: "1rem", lg: "1rem", xl: "2rem" },
                              paddingTop: { mini: "0.5rem", md: "0rem", lg: "1rem" },
                              flex: 1,
                              display: "grid",
                              alignItems: "start",
                              position: "relative",
                            }}
                            >
                            <SoftBox sx={{ padding: { mini: "0 16px 0 16px", lg: "unset" } }}>
                              <YetiKpiBox kpis={kpis} />
                            </SoftBox>
                          </Box>
                        </SoftBox>
                      </SoftBox>
                    </CustomWidthTooltip>
                  </Grid>
                  <Grid item mini={12}>
                    <LeaderBoard isRealAdmin={isRealAdmin} />
                  </Grid>
                </>
              ) : (
                isAdmin && (
                  <Grid item mini={12} height="10rem">
                    <AddKpiBox />
                  </Grid>
                )
              )}
            </Grid>
            <Box>
              <Footer />
            </Box>
          </Box>
          <Modal open={openModal}>
            <SoftBox sx={style}>
              <SoftBox sx={{textAlign: "center"}}>
                <img src={onBoardingImage} alt="onboarding"/>
                <SoftTypography sx={{color: "#344054", fontWeight: "bold", fontSize: "20px", lineHeight: "24px", marginTop: "2rem"}} variant="h1" component="h1">
                  Welcome to Your GameMyBiz Dashboard!
                </SoftTypography>
                <SoftTypography sx={{color: "#667085", fontWeight: "400", fontSize: "16px", lineHeight: "24px", marginTop: "1rem"}} variant="p" component="p">
                  Get ready to level up your productivity and engagement.<br />
                  Would you like to take a quick tour to learn more?
                </SoftTypography>
                <SoftButton onClick={handleCloseModal} 
                    sx={{
                      background: "#F9FAFB", 
                      color: "#475467", 
                      borderRadius: "8px", 
                      marginTop: "2rem",
                      border: "1px solid #EAECF0",
                      boxShadow: "none !important",
                      padding: "16px 32px"
                      }}>
                  Take a quick Product Tour
                </SoftButton>
                <SoftTypography sx={{color: "#667085", fontWeight: "400", fontSize: "16px", lineHeight: "24px", marginTop: "1rem", cursor: "pointer"}} variant="p" component="p" onClick={handleCloseModal2}>
                  Skip Tour and Explore on Your Own
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          </Modal>
        </SoftBox>
      )}
    </SoftBox>
  );
}

export default Homepage;